import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white px-6 py-4" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-end mt-3"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-toggle-off mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-toggle-on mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.item.description), 1),
      _createVNode(_component_cheap, {
        class: _normalizeClass(["small ml-3", { green: _ctx.item.is_active }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.item.is_active ? 'Включено' : 'Выключено'), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("p", null, "key: " + _toDisplayString(_ctx.item.key), 1),
    (_ctx.isCanEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.item.is_active)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                loading: _ctx.state.is_disabling,
                class: "primary text small",
                onClick: _ctx.disableSetting
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" Выключить ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : (_openBlock(), _createBlock(_component_the_button, {
                key: 1,
                loading: _ctx.state.is_enabling,
                class: "primary text small",
                onClick: _ctx.enableSetting
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" Включить ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}